import axios from "axios";

const SERVICES_URL = process.env.SERVICES_URL;
const API_URL = `${SERVICES_URL}/umpire`;

export type UmpireView = {
    umpireStatsId: number;
    name: string;
    email?: string;
    status?: string;
    numberGuests?: number;
    level?: string;
};

export const getUmpireGuests = (
    umpireStatsId: number,
    seasonId: number,
    cancelSource: any,
): Promise<any> =>
    axios
        .get(`${API_URL}/umpireGuest?umpireStatsId=${umpireStatsId}&seasonId=${seasonId}`, {
            cancelToken: cancelSource.token,
        })
        .then(response => response.data);

export const deleteUmpireGuest = (umpireGuestId: number): Promise<any> =>
    axios
        .delete(`${API_URL}/umpireGuest?umpireGuestId=${umpireGuestId}`)
        .then(response => response.data);

export type NewUmpireGuestDtoType = {
    personnel: {
        firstName: string;
        lastName: string;
        middleName?: string;
        nickName?: string;
        email: string;
    };
    umpireStatsId: number;
    umpireGuestAdditionalInfo: {
        relationship: string;
        international: boolean;
    };
};

export type BulkNewUmpireGuestDtoType = {
    newUmpireGuestList: NewUmpireGuestDtoType[];
};

export const addUmpireGuest = (newUmpireGuestDTO: NewUmpireGuestDtoType): Promise<any> =>
    axios.post(`${API_URL}/umpireGuest/add`, newUmpireGuestDTO).then(response => response.data);

export const bulkAddUmpireGuest = (
    bulkNewUmpireGuestDTO: BulkNewUmpireGuestDtoType,
): Promise<any> =>
    axios
        .post(`${API_URL}/umpireGuest/bulk`, bulkNewUmpireGuestDTO)
        .then(response => response.data);

export const getPastUmpireGuests = (
    umpireStatsId: number,
    seasonId: number,
    searchText: string,
    cancelSource: any,
): Promise<any> =>
    axios
        .get(
            `${API_URL}/umpireGuest/past?umpireStatsId=${umpireStatsId}&seasonId=${seasonId}&searchText=${searchText}`,
            {
                cancelToken: cancelSource.token,
            },
        )
        .then(response => response.data);

export const addPastGuests = (pastUmpireGuests: any): Promise<any> =>
    axios
        .post(`${API_URL}/umpireGuest/addPastGuests`, pastUmpireGuests)
        .then(response => response.data);

export const checkForSubmission = (umpireStatsId: number): Promise<any> =>
    axios
        .get(`${API_URL}/umpireGuest/checkForSubmission?umpireStatsId=${umpireStatsId}`)
        .then(response => response.data);

export const submitGuestList = (umpireStatsId: number): Promise<any> =>
    axios
        .post(`${API_URL}/umpireGuest/submitUmpireGuestList?umpireStatsId=${umpireStatsId}`)
        .then(response => response.data);

export const getAllUmpires = (): Promise<any> =>
    axios.get(`${API_URL}/umpireGuest/all`).then(response => response.data);

export const getActiveUmpires = (): Promise<UmpireView[]> =>
    axios.get(`${API_URL}/active`).then(response => response.data);

export const usedUmpireGuestPasses = (): Promise<any> =>
    axios.get(`${API_URL}/umpireGuest/usedUmpireGuestPasses`).then(response => response.data);

export const totalUmpireGuestPasses = (): Promise<any> =>
    axios.get(`${API_URL}/umpireGuest/totalUmpireGuestPasses`).then(response => response.data);
